import { InputText } from '@components-common/forms';
import { TTFormInputPropsGeneric } from './input.types';

export const InputName = ({id = "name", ...rest}: TTFormInputPropsGeneric) => (<InputText id={id} {...rest} />)
